import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
})
export class ClickOutsideDirective {
  @Output() appClickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: MouseEvent): void {
    if (!event.target) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(
      event.target as Node,
    );

    if (!clickedInside) {
      this.appClickOutside.emit();
    }
  }
}
